import { GREY_800, GREY_900, SIZING_5, SPACING_1, SPACING_3, remCalc } from '@mnd-frontend/ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNewsroomSetup } from '../../../../contexts/NewsroomSetupContext';
import { EmptyPressRelease, WrapperForEmptyReleases } from './shared';

const ContentWrapper = styled.div<{ $brandColor: string }>`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  position: relative;
  padding: ${SPACING_3};
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #f7f7f9;
    height: ${SIZING_5};
    border-radius: 6px 6px 0 0;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${SIZING_5};
    border-radius: 0px 0px 6px 6px;
    background: ${props => props.$brandColor};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_1};
  align-items: center;
`;

const Headline = styled.h3`
  font-size: ${remCalc(12)};
  line-height: ${remCalc(20)};
  font-weight: bold;
  margin: 0;
  color: ${GREY_900};
`;

const Description = styled.p`
  font-size: ${remCalc(11)};
  line-height: ${remCalc(17)};
  color: ${GREY_800};
  text-align: center;
`;

const PreviewCompanyDescription = () => {
  const { t } = useTranslation();
  const { newsroomData } = useNewsroomSetup();
  const { secondaryBrandColor } = newsroomData.branding;
  const { companyDescription, tagline } = newsroomData['company-description'];

  return (
    <ContentWrapper $brandColor={secondaryBrandColor}>
      <WrapperForEmptyReleases $position="top">
        <EmptyPressRelease $flex={0.5} $height={20} $boxShadow />
      </WrapperForEmptyReleases>
      <Content>
        <Headline>{tagline || t('newsroom_settings-general_settings-slogan-input_label')}</Headline>
        <Description>{companyDescription || t('common_description')}</Description>
      </Content>
    </ContentWrapper>
  );
};

export default PreviewCompanyDescription;
